export default __webpack_public_path__ + "static/media/gallery_00.c2e2f1d2.jpg";